import type {
  FileItemDisplayMode,
  FileItemFitMode,
  FileItemSizingMode,
} from "../../../canvas/state/types";

type Option<T> = {
  label: string;
  value: T;
};

export const displayModeOptions: Array<Option<FileItemDisplayMode>> = [
  { label: "First image", value: "first-image" },
  { label: "All images", value: "all-images" },
];

export const fitModeOptions: Array<Option<FileItemFitMode>> = [
  { label: "Fit", value: "fit" },
  { label: "Fill", value: "fill" },
  { label: "Stretch", value: "stretch" },
];

export const sizingOptions: Array<Option<FileItemSizingMode>> = [
  { label: "Square thumbnails", value: "square" },
  { label: "Fixed height, automatic width", value: "fixed-height" },
  { label: "Fixed width, automatic height", value: "fixed-width" },
];

export const defaultImageSize = 200;
export const defaultImagePadding = 0;
